<template>
  <div>
    <Form :create="false" :description-title="'Altere os dados cadastrais desse evento'">
      <CreateButton
        @click="updateSector()"
        :icon="PhNotePencil"
        :label="'Atualizar'"
      />
    </Form>
  </div>
</template>

<script setup>
import ExtinguisherService from '../service/event.service'
import CreateButton from '@/components/Buttons/Create.vue'
import Form from '../components/RegisterForm.vue'
import {
  cleanAllFormFields,
  setFormFieldsError,
  validateFormField
} from '@/helpers/formFieldsHandler'
import { showToast as toast } from '@/helpers/UseToasts'
import { PhNotePencil } from '@phosphor-icons/vue'
import { dataEvent } from '../store'
import { storeApp } from '@/store'
import * as yup from '@/validator'
import EventService from '../service/event.service'

const store = dataEvent.state
const appStore = storeApp.state

const schema = yup.object().shape({
  events: yup.object().shape({
    title: yup.string().required('Informe um titulo').label('Titulo'),
    starts_at: yup.string().required('Informe o inicio do evento'),
    is_live: yup.string().required('Informe se é um evento ao vivo'),
    is_private: yup.string().required('Informe se o evento é privado'),
    requires_payment: yup.string().required('Informe se o evento é gratuito')
  })
})

const isFile = (value) => {
  return value instanceof File ||
    (typeof value === 'object' && value?.name)
}

const isStringNotEmpty = (value) => {
  return typeof value === 'string' && value.trim() !== '' && value !== '[]'
}

async function updateSector () {
  appStore.loading = true

  cleanAllFormFields()
  const validate = await validateFormField(schema, store)

  if (validate && validate.length > 0) {
    setFormFieldsError(validate)
    appStore.loading = false
    return
  }

  // validaçãop do banner
  try {
    const banner = store.events?.banner
    const bannerName = store.events?.bannerName

    if (typeof banner !== 'string' && !isFile(banner) && isStringNotEmpty(bannerName)) {
      const res = await EventService.editImage(banner, bannerName)
      store.events.banner = res.data
      store.events.bannerName = res.data
    } else if (isFile(banner)) {
      const res = await EventService.saveImage(banner)
      store.events.banner = res.data
      store.events.bannerName = res.data
    } else if (isStringNotEmpty(bannerName)) {
      store.events.banner = bannerName
    } else {
      store.events.banner = banner
    }
  } catch (err) {
    toast('Aviso', 'Falha no upload do arquivo.', 'error')
  }

  delete store.events?.bannerName
  
  if(store.events?.requires_payment == true)
    store.events.price = null

  await ExtinguisherService.newEvent(store.events)
    .then((res) => {
      if (res?.data?.success) {
        Promise.all([
          getEvents()
        ])

        toast(
          'Sucesso',
          res?.data?.message,
          'success'
        )
      }

      appStore.loading = false
    })
    .catch((err) => {
      appStore.loading = false

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast('Aviso', err.response.data.message, 'error')
      }

      return toast('Aviso', 'Algo deu errado ao registrar documento', 'error')
    })
}

async function getEvents () {
  await EventService.getEvents()
    .then((res) => {
      dataEvent.dispatch('setAllEvents', res.data)
    })
    .catch((err) => {
      console.log(err)
    })
}

</script>
